<template>
  <tr>
    <th :class="{ 'claw-th': name === 'claw' }" v-html="th" />
    <td v-for="(item, index) in specification" :key="index">
      {{ item[name] }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ["th", "name", "specification"],
}
</script>

<style lang="scss">
.claw-th {
  line-height: 2.5 !important;
}
</style>